import { Component, OnInit, OnDestroy } from "@angular/core";

import { DataService_viewvisitor } from "../shared/data.service";

import { wsVPPAdminVisitorImportBlockDataParm } from "../shared/wsVPPAdminVisitorImportBlockDataParm";
import { wsVPPAdminVisitorImportBlockDataInfo } from "../shared/wsVPPAdminVisitorImportBlockDataInfo";
import { wsVPPAdminVisitorImportBlockDataFacilityInfo } from "../shared/wsVPPAdminVisitorImportBlockDataInfo";
import { wsVPPAdminVisitorImportBlockDataImportItemInfo } from "../shared/wsVPPAdminVisitorImportBlockDataInfo";
import { wsVPPAdminVisitorImportBlockedListParm } from "../shared/wsVPPAdminVisitorImportBlockedListParm";
import { wsVPPAdminVisitorImportBlockedListItems } from "../shared/wsVPPAdminVisitorImportBlockedListParm";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

import { ImportBlockItemPhotoInfo } from "../shared/ImportBlockItemPhotoInfo";
import { ImportBlockItemMapInfo } from "../shared/ImportBlockItemMapInfo";

import { exit } from "process";

@Component({
	selector: "app-root",
	templateUrl: "./importblock.component.html",
	styleUrls: ["./importblock.component.css"],
	providers: [ConfirmationService],
})
export class ImportBlockComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_viewvisitor,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;
	public isSkipFirstRow: boolean = false;

	public UserID: number;
	public UserLevelID: number;

	public selectedGroupValue: string = "1";

	public VPPAdminVisitorImportData: wsVPPAdminVisitorImportBlockDataInfo;

	public lstFacilityItems: wsVPPAdminVisitorImportBlockDataFacilityInfo[] = [];
	public SelectedFacility: wsVPPAdminVisitorImportBlockDataFacilityInfo;

	public lstImportItems: wsVPPAdminVisitorImportBlockDataImportItemInfo[] = [];

	public lstBlockItems = [];
	public lstColumns = [];

	// 0 = [Selected Count]
	// 1 = [Selected Loaded Success Count]
	// 2 = [Selected Loaded Error Count]
	// 3 = [IsLoading]
	public SelectedCounts: any[] = [0, 0, 0, 0];

	//	Image Processing
	public TotalImagesLoaded: ImportBlockItemPhotoInfo[] = [];

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserID = this.dialogConfig.data.UserID;
		this.UserLevelID = this.dialogConfig.data.UserLevelID;

		if (this.UserLevelID == 1) {
			// District Level
			this.selectedGroupValue = "1";
		} else {
			this.selectedGroupValue = "2";
		}

		let parms: wsVPPAdminVisitorImportBlockDataParm = {
			UserID: this.UserID,
		};

		this.isBusy = true;
		this.dataService.VPPAdminVisitorImportBlockDataGet(parms).subscribe((data) => this.VPPAdminVisitorImportBlockDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorImportBlockDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorImportBlockDataGet_Complete(data: any) {
		this.VPPAdminVisitorImportData = data;

		this.lstFacilityItems = this.VPPAdminVisitorImportData.FacilityItems;
		this.lstImportItems = this.VPPAdminVisitorImportData.ImportItems;

		//
		//	Select Default Facility
		//
		this.SelectedFacility = this.lstFacilityItems[0];

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onLoadBlockList
	//
	//-----------------------------------------------------------------------------------------------------
	onLoadBlockList(event: any) {
		if (event.target.files && event.target.files[0]) {
			let reader = new FileReader();

			reader.onload = (e: any) => {
				this.ParceBlockList(event.target.files[0], e.target.result, this);
			};

			reader.readAsText(event.target.files[0]);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ParceBlockList
	//
	//-----------------------------------------------------------------------------------------------------
	ParceBlockList(imgfile: any, imgfiledata: any, _this: this) {
		//
		//	Determine What delimiter to use (TAB or COMMA)
		//
		let countTAB = 0;
		let countComma = 0;
		let DELIMITER = "\t";

		for (let i = 0; i < imgfiledata.length; i++) {
			if (imgfiledata.substr(i, 1) == ",") {
				countComma++;
			}

			if (imgfiledata.substr(i, 1) == "\t") {
				countTAB++;
			}
		}

		if (countTAB < 2 && countComma < 2) {
			this.ErrorMessage = "Invalid Block List. delimiter is invalid";
			return;
		} else {
			if (countTAB >= countComma) {
				DELIMITER = "\t";
			} else {
				DELIMITER = ",";
			}
		}

		//
		//	Split using delimiter
		//
		let lstParce = imgfiledata.split("\r\n").map((line) => line.split(DELIMITER));

		//
		//	Add Column 0 For Photo Validation
		//
		lstParce.forEach((item) => {
			item.unshift("");
		});

		//
		//	Get Column Count (MAX)
		//
		let colCount = 0;

		lstParce.forEach((item) => {
			if (item.length > colCount) {
				colCount = item.length;
			}
		});

		//
		//	Remove Rows < Column Count (MAX)
		//
		this.lstBlockItems = lstParce.filter(function (item) {
			return item.length == colCount;
		});

		//
		//	Remove First Row if isSkipFirstRow = True
		//
		if (this.isSkipFirstRow == true) {
			this.lstBlockItems.shift();
		}

		//
		//	Build Column Map
		//
		this.lstColumns = [];

		for (let i = 0; i < colCount; i++) {
			this.lstColumns.push("ImportItemCol" + i.toString());
		}

		//
		//	Validate and Map
		//
		this.ValidateBlockList();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	chkSkipFirstRow
	//
	//-----------------------------------------------------------------------------------------------------
	chkSkipFirstRow(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onLoadPhotos
	//
	//-----------------------------------------------------------------------------------------------------
	onLoadPhotos(event: any) {
		console.log("Starting image load..", new Date().toLocaleTimeString("en-US"));

		this.TotalImagesLoaded = [];

		this.SelectedCounts[0] = event.target.files.length; //Selected Count
		this.SelectedCounts[1] = 0; //Selected Loaded Success Count
		this.SelectedCounts[2] = 0; //Selected Loaded Error Count
		this.SelectedCounts[3] = 1; //IsLoading

		// If one or more image selected, Start the call chain to load all selected images)
		if (event.target.files && event.target.files[0]) {
			this.LoadImageAtIndex(event.target.files, 0);
		} else {
			this.SelectedCounts[3] = 0; //IsLoading
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	LoadImageAtIndex
	//
	//-----------------------------------------------------------------------------------------------------
	LoadImageAtIndex(files: any, idx: any) {
		let reader = new FileReader();

		reader.onload = (e: any) => {
			this.ImageAtIndexLoaded(e, files, idx);
		};

		reader.readAsDataURL(files[idx]);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageAtIndexLoaded
	//
	//-----------------------------------------------------------------------------------------------------
	ImageAtIndexLoaded(e: any, files: any, idx: any) {
		//
		//	Browsers now Rotate Image On-Load using Exif info in file)
		//
		//	Resize Image / Push to TotalImagesLoaded[]
		//
		this.ResizeImageAndPush(files[idx], e.target.result, 640);

		//
		// Are there more files left to load?
		//
		if (idx < files.length - 1) {
			// Yes, Load the next file
			this.LoadImageAtIndex(files, idx + 1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ResizeImageAndPush
	//
	//-----------------------------------------------------------------------------------------------------
	ResizeImageAndPush(imgfile: any, imgfiledata: any, MAX_SIZE: any) {
		// Note: SelectedCounts contain the following counts
		// SelectedCounts[0] = Selected Count
		// SelectedCounts[1] = Selected Loaded Success Count
		// SelectedCounts[2] = Selected Loaded Error Count
		// SelectedCounts[3] = IsLoading

		let _this = this;

		// Create work image for resizing
		let img = document.createElement("img");

		img.onerror = function () {
			_this.SelectedCounts[2]++;

			//
			// Are We Done Yet?
			//
			if (_this.SelectedCounts[1] + _this.SelectedCounts[2] == _this.SelectedCounts[0]) {
				_this.SelectedCounts[3] = 0; //IsLoading
				console.log("Image load complete with errors..", new Date().toLocaleTimeString("en-US"));
			}
		};

		img.onload = function () {
			let width = img.width;
			let height = img.height;

			if (width >= height) {
				// Landscape
				height = Math.round(img.height * (MAX_SIZE / img.width));
				width = MAX_SIZE;
			} else {
				// Portrait
				width = Math.round(img.width * (MAX_SIZE / img.height));
				height = MAX_SIZE;
			}

			let canvas = document.createElement("canvas");

			canvas.width = width;
			canvas.height = height;

			let ctx = canvas.getContext("2d");

			ctx.drawImage(img, 0, 0, width, height);

			let obj = {
				PhotoName: imgfile.name,
				PhotoUrl: canvas.toDataURL("image/jpeg"),
			};

			_this.TotalImagesLoaded.push(obj);
			_this.SelectedCounts[1]++;

			//
			// Are We Done Yet?
			//
			if (_this.SelectedCounts[1] + _this.SelectedCounts[2] == _this.SelectedCounts[0]) {
				_this.SelectedCounts[3] = 0; //IsLoading
				console.log("Image load complete..", new Date().toLocaleTimeString("en-US"));

				//
				//	Validate and Map
				//
				_this.ValidateBlockList();
			}
		};

		// Load The Image Data
		img.src = imgfiledata;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onGroupChange
	//
	//-----------------------------------------------------------------------------------------------------
	onGroupChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFacilityChange
	//
	//-----------------------------------------------------------------------------------------------------
	onFacilityChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onImportItemChange
	//
	//-----------------------------------------------------------------------------------------------------
	onImportItemChange(event) {
		//
		//	Validate and Map
		//
		this.ValidateBlockList();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onImportBlock
	//
	//-----------------------------------------------------------------------------------------------------
	onImportBlock() {
		if (this.ValidateBlockList() == false) {
			//
			// Upload Block List To Server
			//
			let lstBlockItemMap: ImportBlockItemMapInfo[] = [];

			for (let i = 0; i < this.lstColumns.length; i++) {
				let selcol = (<HTMLInputElement>document.getElementById("ImportItemCol" + i.toString()))?.value ?? "Don't Import";

				let item: ImportBlockItemMapInfo = {
					ColumnNbr: i,
					ItemName: selcol,
				};

				lstBlockItemMap.push(item);
			}

			var lstFilteredMap = lstBlockItemMap.filter(function (item) {
				if (item.ItemName != "Don't Import") {
					return true;
				} else {
					return false;
				}
			});

			//
			//	Build lstUploadItems to upload to server
			//
			let lstUploadItems: wsVPPAdminVisitorImportBlockedListItems[] = [];

			let workFacilityID = -1;

			if (this.selectedGroupValue == "2") {
				workFacilityID = this.SelectedFacility.FacilityID;
			}

			let rUploadBlocked: wsVPPAdminVisitorImportBlockedListParm = {
				FacilityID: workFacilityID,
				BlockItems: lstUploadItems,
			};

			this.lstBlockItems.forEach((item) => {
				let rBlocked: wsVPPAdminVisitorImportBlockedListItems = {
					FirstName: "",
					MiddleName: "",
					LastName: "",
					Email: "",
					SSN: "",
					GenderCD: "",
					DOB: "",
					Street1: "",
					Street2: "",
					City: "",
					State: "",
					Zip: "",
					HomePhone: "",
					CellPhone: "",
					WorkPhone: "",
					Height: "",
					Weight: "",
					EyeColor: "",
					HairColor: "",
					Person_Image: "",
				};

				lstFilteredMap.forEach((col) => {
					if (col.ItemName == "FirstName") {
						rBlocked.FirstName = item[col.ColumnNbr];
					}

					if (col.ItemName == "MiddleName") {
						rBlocked.MiddleName = item[col.ColumnNbr];
					}

					if (col.ItemName == "LastName") {
						rBlocked.LastName = item[col.ColumnNbr];
					}

					if (col.ItemName == "Email") {
						rBlocked.Email = item[col.ColumnNbr];
					}

					if (col.ItemName == "SSN") {
						rBlocked.SSN = item[col.ColumnNbr];
					}

					if (col.ItemName == "Gender") {
						rBlocked.GenderCD = item[col.ColumnNbr];
					}

					if (col.ItemName == "DOB") {
						rBlocked.DOB = item[col.ColumnNbr];
					}

					if (col.ItemName == "Street1") {
						rBlocked.Street1 = item[col.ColumnNbr];
					}

					if (col.ItemName == "Street2") {
						rBlocked.Street2 = item[col.ColumnNbr];
					}

					if (col.ItemName == "City") {
						rBlocked.City = item[col.ColumnNbr];
					}

					if (col.ItemName == "State") {
						rBlocked.State = item[col.ColumnNbr];
					}

					if (col.ItemName == "Zip") {
						rBlocked.Zip = item[col.ColumnNbr];
					}

					if (col.ItemName == "HomePhone") {
						rBlocked.HomePhone = item[col.ColumnNbr];
					}

					if (col.ItemName == "CellPhone") {
						rBlocked.CellPhone = item[col.ColumnNbr];
					}

					if (col.ItemName == "WorkPhone") {
						rBlocked.WorkPhone = item[col.ColumnNbr];
					}

					if (col.ItemName == "Height") {
						rBlocked.Height = item[col.ColumnNbr];
					}

					if (col.ItemName == "Weight") {
						rBlocked.Weight = item[col.ColumnNbr];
					}

					if (col.ItemName == "EyeColor") {
						rBlocked.EyeColor = item[col.ColumnNbr];
					}

					if (col.ItemName == "HairColor") {
						rBlocked.HairColor = item[col.ColumnNbr];
					}

					if (col.ItemName == "EyeColor") {
						rBlocked.EyeColor = item[col.ColumnNbr];
					}

					if (col.ItemName == "(Photo)") {
						this.TotalImagesLoaded.forEach((photo) => {
							if (photo.PhotoName == item[col.ColumnNbr]) {
								rBlocked.Person_Image = photo.PhotoUrl;
							}
						});
					}
				});

				lstUploadItems.push(rBlocked);
			});

			this.isBusy = true;
			this.dataService.VPPAdminEditVisitorAddBlockedList(rUploadBlocked).subscribe((data) => this.VPPAdminEditVisitorAddBlockedList_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ValidateBlockList
	//
	//-----------------------------------------------------------------------------------------------------
	ValidateBlockList() {
		let isError = false;
		this.ErrorMessage = "";

		let lstBlockItemMap: ImportBlockItemMapInfo[] = [];
		let PhotoColumnNbr = 0;
		let isPhotoColumnSet = false;
		let isFirstNameColumnSet = false;
		let isLastNameColumnSet = false;

		//
		//	Build lstBlockItemMap and set PhotoColumnNbr
		//
		for (let i = 0; i < this.lstColumns.length; i++) {
			let selcol = (<HTMLInputElement>document.getElementById("ImportItemCol" + i.toString()))?.value ?? "Don't Import";

			if (selcol == "(Photo)" && isPhotoColumnSet == false) {
				PhotoColumnNbr = i;
				isPhotoColumnSet = true;
			}

			if (selcol == "FirstName") {
				isFirstNameColumnSet = true;
			}

			if (selcol == "LastName") {
				isLastNameColumnSet = true;
			}

			let item: ImportBlockItemMapInfo = {
				ColumnNbr: i,
				ItemName: selcol,
			};

			lstBlockItemMap.push(item);
		}

		//
		// Set Photo Loaded Column #
		//
		this.lstBlockItems.forEach((item) => {
			item[0] = "";

			this.TotalImagesLoaded.forEach((photo) => {
				if (item[PhotoColumnNbr] == photo.PhotoName) {
					item[0] = "YES";
				}
			});
		});

		//
		//	Check For Duplicate Columns Selected, and Set hasDuplicates
		//
		var lstFiltered = lstBlockItemMap.filter(function (item) {
			if (item.ItemName != "Don't Import") {
				return true;
			} else {
				return false;
			}
		});

		var valueArr = lstFiltered.map(function (item) {
			return item.ItemName;
		});

		var hasDuplicates = valueArr.some(function (item, idx) {
			return valueArr.indexOf(item) != idx;
		});

		//
		//	Set Error Message
		//
		if (isFirstNameColumnSet == false || isLastNameColumnSet == false) {
			this.ErrorMessage = "First Name and Last Name are required fields.";
			isError = true;
		}

		if (hasDuplicates == true) {
			this.ErrorMessage = "You have set more than one import column with the same value.";
			isError = true;
		}

		return isError;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminEditVisitorAddBlockedList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminEditVisitorAddBlockedList_Complete(data: any) {
		this.ErrorMessage = "";
		this.isBusy = false;

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
